import { type ReactNode, useEffect, useState } from 'react'
import { LoadingIndicator } from '@web-apps/ui-shared'

import {
  hasRNWebViewCredential,
  RN_AUTH_READY_EVENT,
} from '../../utils/helpers/rnWebView.helpers'

type Props = {
  isNativeAuthRequired: boolean
  children: ReactNode
}

const CREDENTIAL_WAIT_TIMEOUT_MS = 5000

export const RNWebViewAuthWrapper = ({
  isNativeAuthRequired,
  children,
}: Props): JSX.Element => {
  const [isReady, setIsReady] = useState(
    () => !isNativeAuthRequired || hasRNWebViewCredential()
  )

  useEffect(() => {
    if (!isNativeAuthRequired || isReady) return

    if (hasRNWebViewCredential()) {
      setIsReady(true)
      return
    }

    const handler = () => setIsReady(true)
    window.addEventListener(RN_AUTH_READY_EVENT, handler)

    const timeout = setTimeout(
      () => setIsReady(true),
      CREDENTIAL_WAIT_TIMEOUT_MS
    )

    return () => {
      window.removeEventListener(RN_AUTH_READY_EVENT, handler)
      clearTimeout(timeout)
    }
  }, [isNativeAuthRequired, isReady])

  if (!isReady) return <LoadingIndicator size={100} isCentered />
  return <>{children}</>
}
